export const GENERATED_IDS = {
    "__MODIFIER_ID": {
        "MASTERS_CALL": "97cecb8f-4f90-4c43-8a0e-d18e8a424303"
    },
    "__SPELL_ID": {
        "DH": {
            "HAVOC": {
                "DARKNESS": "cf47dd1b-57ce-4ff0-90c1-0066a187718b"
            },
            "VENG": {
                "DARKNESS": "dcf29b11-b583-4da1-8e7b-eb072d5003d3"
            }
        },
        "DK": {
            "BLOOD": {
                "ABOM_LIMB": "a351975d-4d53-440a-8fe5-13836f8e86e4",
                "AMZ": "ea074334-e633-46bd-9958-3fdb463068fd",
                "GRASP": "ef6d59d7-7522-4b4c-9111-9f554edd4614"
            },
            "FROST": {
                "ABOM_LIMB": "88024cd3-bfc6-42c5-a1b5-a277b51407d8",
                "AMZ": "3b16750b-c297-4cc0-9ded-5151749bc1fe"
            },
            "UNHOLY": {
                "ABOM_LIMB": "36e3f2a2-2ab9-4115-9a36-9a66c5a8ebd5",
                "AMZ": "149105e0-feb0-4535-bfc6-27239ada49ce"
            }
        },
        "DRUID": {
            "BALANCE": {
                "INNERVATE": "63e24cd3-74af-4050-a6c1-091a4854ed98",
                "ROAR": "6a8f3c04-6fc2-4757-8a68-84d59c7b3e46",
                "VIGIL": "a18258ed-6fbd-4a5b-928f-5664f54ba566",
                "VORTEX": "f5761e2f-fb64-4165-afb2-7be13df8da66"
            },
            "FERAL": {
                "INNERVATE": "98043a6f-447a-4d3e-8eb6-44368e5ba2bd",
                "ROAR": "b8cb697b-d456-4489-9d61-d0a286129d55",
                "VIGIL": "2631857d-abdc-4f01-9639-48815ab13616",
                "VORTEX": "2108e3a6-f8f7-47f1-948b-eef23d7c3899"
            },
            "GUARDIAN": {
                "INNERVATE": "83f198c3-72fe-45a3-8a71-23e848414d30",
                "ROAR": "03897498-b6bc-478e-bcb4-3da8f178ae43",
                "VIGIL": "7d7162a5-7e78-4957-973d-1b226afd667c",
                "VORTEX": "e27a01f2-41c4-4f8f-ab6f-7b3e95a5d5a6"
            },
            "RESTO": {
                "CONVOKE": "ebb778df-bef7-4ffa-8820-195aed3e8f40",
                "IRONBARK": "2e788ebd-4f2f-4a77-8cad-fd108af4a159",
                "ROAR": "5171e67e-edba-4ca5-a90a-20216088e900",
                "TRANQ": "f1731241-a892-464e-8b03-ca55f727e65a",
                "TREE": "864c11d9-76e9-46bc-8d57-83a78694d5c3",
                "VORTEX": "546b181c-e440-4a39-a5d6-a7760a09526f"
            }
        },
        "EVOKER": {
            "AUG": {
                "RESCUE": "13a13f04-2165-4dcc-8c30-e478e805ebb6",
                "SPAT_PARADOX": "359100cf-3a6a-4ea5-b2b3-5863e4c0da04",
                "SPIRAL": "226e9a3c-34a1-4cc6-a4c4-40192975733d",
                "ZEPHYR": "fe0aa554-2490-4bdc-b674-0eec49b04bc4"
            },
            "DEVA": {
                "RESCUE": "06c8b627-79ac-4f1f-8229-fa69ec922b20",
                "SPAT_PARADOX": "baf7f1e4-f326-4ff2-9dfb-42d0f05f120e",
                "SPIRAL": "e7f75540-166c-4cbb-a69d-3589acd7691e",
                "ZEPHYR": "cd92e6a0-814a-46f9-b63b-c3e41f965dd8"
            },
            "PRES": {
                "DREAM_FLIGHT": "a82b3af9-5f7f-4848-8a8c-9085a1e66a49",
                "EM_COM": "c29a1e24-cdf1-4a90-8f66-0f710de6b95f",
                "RESCUE": "d322ee3a-ae53-442b-a1cf-664f2d61d04b",
                "REWIND": "f5ef4208-c8b1-4ac0-9e72-2d5fd1588b69",
                "SPAT_PARADOX": "87749372-54d2-419f-916d-7799b8d3f40d",
                "SPIRAL": "6322bfa2-4658-493d-ac8d-4dce32f0d793",
                "TIME_DIALATION": "16979d3b-3831-4d0b-8266-af4f5847ef58",
                "ZEPHYR": "0b91fae5-c221-4816-8ae6-995b2ee34a04"
            }
        },
        "HUNTER": {
            "BM": {
                "MASTERS_CALL": "09704b27-46b4-4a33-a5b5-bc0f60360b0b",
                "TURTLE": "c71b94d6-8470-436b-afd8-1aee1981099d"
            },
            "MM": {
                "MASTERS_CALL": "5ed0a91e-1880-4f9a-b644-4c13470a61e5",
                "TURTLE": "38094d11-eef8-4047-ae8e-b8e513ee7da8"
            },
            "SV": {
                "MASTERS_CALL": "7917bfe4-1e09-4e4a-94ff-4afeb3745797",
                "TURTLE": "a945fd6b-ec7b-42b4-8025-7671b2c79e6c"
            }
        },
        "MAGE": {
            "ARCANE": {
                "HPPOT": "31fdaf76-04ec-434d-a817-c022448c3678",
                "HS": "905c4d07-80a8-4d0c-97d5-d29c0bde98ba",
                "MASS_BARRIER": "6583c72c-4b79-4435-bae9-fcc1b5c32d17",
                "PERSONAL2MIN": "cab7cdd0-1733-4f2b-9e3c-2f9dacb84cc8"
            },
            "FIRE": {
                "MASS_BARRIER": "9c6ad09a-828e-4c60-a9a2-c3d2f244d941"
            },
            "FROST": {
                "MASS_BARRIER": "6e002afb-b81e-45ff-acbb-049081b3d052"
            }
        },
        "MONK": {
            "BRM": {
                "SWEEP": "8aec93d2-2aff-49ec-adc7-7c7dacd98380",
                "TIGERS_LUST": "c21f4b62-777b-408f-81ed-98ef91a62fb8"
            },
            "MW": {
                "CHI_JI": "7ceb50d9-f44b-4ff8-bf75-5a432b340c0d",
                "COCOON": "76430eb8-165c-4f9f-a619-4ee302197f32",
                "REVIVAL": "1933d67f-b51a-4749-a6dc-012a6be0726b",
                "SWEEP": "e791e627-d68b-4dcc-9e37-ce471e86b268",
                "TIGERS_LUST": "12de984d-13e9-416d-aa95-de2194c07251",
                "YULON": "e1d00dfa-fff5-424c-adef-7da054dc3897"
            },
            "WW": {
                "SWEEP": "ab6f223c-68a1-479e-b033-e41f6fc8ea49",
                "TIGERS_LUST": "2dfdca50-d43e-4051-9889-86a0af8e4d11"
            }
        },
        "PALADIN": {
            "HOLY": {
                "AM": "05e0b6a4-18d0-4820-8c8e-cbb379cb8634",
                "AVENGING_WRATH": "ca893cdb-27d4-4fdc-8534-4f61461ce940",
                "BLESS_SAC": "2bce4547-fce7-4d62-b894-2018ef2589ef",
                "BOP": "c4104b9d-26b6-4cd2-8dc9-f346f94346c5",
                "CRUSADER": "bf98a80a-a8a5-4d0e-bc27-1e71fbacb7f9",
                "DIVINE_TOLL": "2d0bf39e-ccef-44b9-b8a2-c6ccf254fbc9",
                "DIV_SHIELD": "58faeff0-a646-4a51-a1fa-5edf41381f34",
                "FREEDOM": "781ef5af-1d36-4492-bc2f-43ec32d57e34",
                "TYR_DELIVERANCE": "e4fc858c-8c0d-4dd3-a155-c970a14dba92"
            },
            "PROT": {
                "BLESS_SAC": "56d42104-e78f-46d5-9f56-a7e2bc8ca6ca",
                "BOP": "fb72136a-1814-46eb-bf51-4dc08461274d",
                "DIV_SHIELD": "5d50199c-9064-4adb-8d76-3e2651510e31",
                "FREEDOM": "cb1a07db-73ca-46da-abac-e8a5bbb4a6ad",
                "SPELLWARDING": "7ec6fd94-a652-4491-a1b7-32a977ab331e"
            },
            "RET": {
                "BLESS_SAC": "aec2b540-401c-4d38-a747-b6416e11b018",
                "BOP": "38e8bdc2-7193-4359-b3bb-5ef89e6df63f",
                "DIV_SHIELD": "a328e53b-28a9-4fa5-87e7-e71eeb7b2b5b",
                "FREEDOM": "12af0606-3665-4be2-9d2b-1d2776f7e827"
            }
        },
        "PRIEST": {
            "DISC": {
                "BARRIER": "b9c5c635-ebd2-407e-a9c4-143df8566bce",
                "BENDER": "16b54a37-4c8a-4a9e-974c-63ec64724a6d",
                "EVANG": "4ca718b9-1e94-4b2d-8988-18fbb6b3bfdc",
                "FIEND": "ed7bf7a5-d61b-4276-9182-c8ee0cad090e",
                "LEAP_OF_FAITH": "08498d00-d197-4fad-bf1a-29e6fb2caec2",
                "MASS_DISPEL": "688d3cff-a59f-4bc8-8c67-84a616649881",
                "PAINSUP": "98a8efbd-f141-4487-9505-180b0ffb067f",
                "POWER_INFUSION": "266fff1a-966f-42de-830e-b7edbedcfa86",
                "RAPT": "d3e989d5-5153-45d5-a442-8fa2c926661c",
                "ULTI_PEN": "04e8fdc0-0c2d-4ea5-980a-7ad7c34786e5"
            },
            "HOLY": {
                "APO": "ca1bd677-a9dd-4850-ac8f-5557466b2da3",
                "GUARDIAN_SPIRIT": "1ace0b3c-c69b-4078-8dca-e1972e7e12b2",
                "HYMN": "dbabf9cc-7f51-4727-8b44-c0cb6a1a4342",
                "LEAP_OF_FAITH": "cfb7415b-728a-43b6-a2f1-fb829c149c8c",
                "MASS_DISPEL": "c79698a5-28cd-4797-88a8-e7d83df40d45",
                "POWER_INFUSION": "a779de5c-f483-4fa1-aa40-43581326f792",
                "SALV": "8350ad72-337c-4c95-844c-18eea40a8c8b",
                "SYMBOL_OF_HOPE": "cb951cc4-f66a-401e-a3fc-2d8088ca2407"
            },
            "SHADOW": {
                "LEAP_OF_FAITH": "91dc9c20-57a2-4220-92b8-6395b97d6bd5",
                "MASS_DISPEL": "7aeb468b-c67a-44ce-a38e-f7ce21d5abad",
                "VAMP_EMBRACE": "99b1990f-4cce-4f10-8a2d-4a7c2f8b449b"
            }
        },
        "ROGUE": {
            "ASS": {},
            "OUT": {},
            "SUB": {}
        },
        "SHAMAN": {
            "ELE": {
                "ANCE_GUIDE": "b73387fc-91ff-40f9-9fdf-0d855927d16e",
                "RECALL": "a5a8d118-41b4-4bfc-81c9-61453aec3832",
                "WRT": "9002f891-b356-4f67-9c0f-f7e512ddb5ef"
            },
            "ENH": {
                "ANCE_GUIDE": "bc7f3a24-3640-4403-8e1d-5f327c0db931",
                "RECALL": "c359b7b7-a981-4c4b-bb80-7bf57e1be922",
                "WRT": "30f48251-6f5b-4d6b-b2be-c04274a1e1f2"
            },
            "RESTO": {
                "ANCE_GUIDE": "d8bcbe43-916e-4bae-aa75-b5d43a3c55cc",
                "APT": "4dcb852c-13d1-4f98-b290-6b7448e12c83",
                "ASC": "9bd01167-e150-4923-9a59-227797e713d0",
                "HTT": "9cdb8790-b5a3-4d6e-9be8-f0146844df8c",
                "MTT": "c749dc6b-7e45-4a5c-beb5-67ebe7e908ab",
                "RECALL": "491d48b9-059d-4d04-904f-2df4b4ef31eb",
                "SLT": "006e6534-a284-4b73-9edf-8e5b7d016036",
                "WRT": "e927283d-2e30-47d0-a11c-d29bc0da0ffd"
            }
        },
        "WARLOCK": {
            "AFFLI": {},
            "DEMO": {},
            "DEST": {}
        },
        "WARRIOR": {
            "ARMS": {
                "RALLY": "aa903e1f-9c6c-46b2-a3a1-1040686a4433"
            },
            "FURY": {
                "RALLY": "7f8a2f91-f4c5-44f0-b88f-8069484976e1"
            },
            "PROT": {
                "RALLY": "755896e9-8f8d-4262-b481-78b35619c227"
            }
        }
    },
    "__TALENT_ID": {
        "DH": {
            "HAVOC": {
                "DARKNESS": "8c99b3d5-62d2-4672-bbec-50eb0f3c8fc2",
                "PITCH_BLACK": "fe615593-20ff-4088-a323-e7087544216e"
            },
            "VENG": {
                "DARKNESS": "bbd1c3c3-96df-45f1-8c59-dea4fee0d9ca",
                "PITCH_BLACK": "a22a383c-ff9b-48d4-b532-1d1941d71774"
            }
        },
        "DK": {
            "BLOOD": {
                "ABOM_LIMB": "2b36a255-0d1f-4edb-ac7d-2f9cca13bfa3",
                "ASSIMILATION": "5859b929-053b-4ddb-b0d7-e14bf3f43d4b",
                "GRASP": "467b7328-32ae-44e2-8532-3f958a7badb8",
                "TIGHT_GRASP": "6798d5c7-eef8-4965-913b-3c60d97760f7"
            },
            "FROST": {
                "ABOM_LIMB": "767e54f0-88e8-417f-9d8a-e487ca01fc6a",
                "ASSIMILATION": "32687d7b-f4b4-45a5-a1d0-d64037b764e3"
            },
            "UNHOLY": {
                "ABOM_LIMB": "36b1b8cd-86d9-43fd-92b7-ac5b1198cd07",
                "ASSIMILATION": "cc962c25-6a3b-4af0-b286-da67b821f3e7"
            }
        },
        "DRUID": {
            "BALANCE": {
                "IMPROVED_ROAR": "a04511c0-e7e5-4877-b694-d2dffa11a5b2",
                "INNERVATE": "81b03fbd-2ac3-49d1-b0d7-0d8aaa97371c",
                "VIGIL": "90c7b081-5aa9-413d-a638-42961d68a966",
                "VORTEX": "4d782bee-99f7-4568-9fad-84058719b8a3"
            },
            "FERAL": {
                "IMPROVED_ROAR": "583dcc89-53be-49c8-a9ac-2a8da54f5ed7",
                "INNERVATE": "82799079-fa85-4f5e-879c-e65b685a5783",
                "VIGIL": "07e2d1df-0a38-4075-adfc-998eb7def218",
                "VORTEX": "45b5c689-fc1e-40a1-bf50-e41365e7456c"
            },
            "GUARDIAN": {
                "IMPROVED_ROAR": "c63562ef-5188-4a55-aefe-6ae707d4fc9d",
                "INNERVATE": "7351775e-92b7-478f-a030-104aaf1d6adc",
                "VIGIL": "24a1ecf6-a951-4652-bd26-2d6b12a3262b",
                "VORTEX": "37a85b35-ee30-4f8a-aad5-679ba20ee2eb"
            },
            "RESTO": {
                "CEN_GUIDANCE": "4f846cbc-f718-43ad-ab0a-812ca4467f23",
                "CONVOKE": "15c1f077-0c6c-4a3a-a75a-02bff29b5664",
                "IMPROVED_ROAR": "c98d366c-eae5-42a5-92e8-1288aa88eb0c",
                "IMPR_IRONBARK": "d48a7d3f-16f6-4e44-bed2-fee66d8ea35a",
                "INNER_PEACE": "5ea2d30f-6c4c-49b9-85d5-0d6995adc68c",
                "TREE": "3c45d7a2-9e52-4017-9f18-3014ffe0e430",
                "VORTEX": "b3ec93a1-6250-452a-ab54-e85e52924163"
            }
        },
        "EVOKER": {
            "AUG": {
                "RESCUE": "73034b1a-bd86-4d63-986d-00767150da9d",
                "SPAT_PARADOX": "aa664140-7871-414a-ac39-5b19c0f56efc",
                "SPIRAL": "a30e6676-997f-4a3a-bb78-d353d6ab618d",
                "ZEPHYR": "29d23e3f-53ed-4fa9-a788-39af5ac8cc21"
            },
            "DEVA": {
                "RESCUE": "db645c3d-704e-43b1-97ef-c6c0f2119c8d",
                "SPAT_PARADOX": "cff1e89d-61b7-475f-8be5-f1b8e0e9badf",
                "SPIRAL": "ba35bc19-6a14-4fe9-99a9-5f86a1d2ba69",
                "ZEPHYR": "9a9316a3-8f95-4cb4-9587-8745777e125f"
            },
            "PRES": {
                "DREAM_FLIGHT": "ab58d1d9-db4d-4e7a-a014-86eaa08c1611",
                "EM_COM": "e9ed1039-2542-45a5-9a7e-0da17313acfa",
                "ERASURE": "ecc35489-c4e9-4f68-8901-74620e18cdc4",
                "RESCUE": "fae8f28c-27b6-4cf9-8ed3-cb1bb3701924",
                "SPAT_PARADOX": "cbf60eb9-cf97-4773-9ac7-0d7604dedaf0",
                "SPIRAL": "4765648f-fc35-4305-bdce-e4353eec9c2c",
                "TEMPORAL_ARTIFICER": "53f260ec-ac2b-4cb4-91b0-1b252665ee23",
                "ZEPHYR": "0d992c62-362c-4dfc-924b-047f67be2ca8"
            }
        },
        "HUNTER": {
            "BM": {
                "BORN_TO_BE_WILD": "48461dc1-c85b-470c-ba5a-269b701ebe18"
            },
            "MM": {
                "BORN_TO_BE_WILD": "e9389c2c-4ab3-49eb-93db-030b2a7f4f38"
            },
            "SV": {
                "BORN_TO_BE_WILD": "a5d22dfd-d455-47b6-9c74-9e6820822273"
            }
        },
        "MAGE": {
            "ARCANE": {
                "HPPOT": "b13f131b-222d-481c-93cb-fe4ac8e4ab9e",
                "HS": "496f5f29-c065-4cfc-9cad-c7c31f51c188",
                "MASS_BARRIER": "40039152-7e24-4b87-9693-459badf45081",
                "PERSONAL2MIN": "94332795-35fc-4c49-bba0-18c103bb408e"
            },
            "FIRE": {
                "MASS_BARRIER": "85050e0d-9137-4795-a826-d43e83b648bd"
            },
            "FROST": {
                "MASS_BARRIER": "e4ef9154-7c60-4f82-b7f4-aee7e072bea1"
            }
        },
        "MONK": {
            "BRM": {
                "ANCIENT_ARTS_1": "d83b8700-8bfa-4601-aa8a-9afc6bf9e019",
                "ANCIENT_ARTS_2": "13db282d-b721-475d-aa6e-bd131791db66"
            },
            "MW": {
                "ANCIENT_ARTS_1": "160dfe8a-fd9e-4a9f-b3b7-844269786fc4",
                "ANCIENT_ARTS_2": "fdf0f7fc-8feb-462c-a253-2711e3406cce",
                "CHI_JI": "1f8e2d40-918d-4603-a15c-59423e2585d7",
                "CHRYS": "7ff235d6-9752-4d3f-a7b5-87d1df11b114",
                "GIFT_OF_CELEST": "d3753af3-0a20-46d8-bd73-0702c8f1826f",
                "TIGERS_LUST": "909f1f5b-a757-443d-b336-cd86f48d1dfd",
                "YULON": "5268ec1f-cde9-4148-ad41-bb67a35df24c"
            },
            "WW": {
                "ANCIENT_ARTS_1": "b79c8b55-8181-4eba-a8f3-d5da08cb994f",
                "ANCIENT_ARTS_2": "a17bab75-7676-4f19-99b2-d83ef3d0ba47",
                "TIGERS_LUST": "dc690ae9-da03-4789-ba73-6a34a9c9f4b0"
            }
        },
        "PALADIN": {
            "HOLY": {
                "AVENGING_WRATH": "2588c632-df3c-4ac7-97c9-b3b2af36df74",
                "BOP": "03d12b2f-f177-4460-9e0e-04238063e477",
                "CRUSADER": "816a3a32-a4d2-4cfb-aad8-47c749c6222f",
                "DIVINE_TOLL": "1bb6cb6a-b5f4-42b0-bb16-93795ebac03e",
                "IMP_BLESSING": "faa69883-c426-46d8-b4c5-78959be4f168",
                "QUICK_INVO": "bb927fdc-86d0-4d3c-868b-962396fb9b96",
                "SAC_JUST": "d8f9ecd6-716b-4389-9d7e-99a1b43a6af9",
                "TYR_DELIVERANCE": "266e2fbc-b0a8-44e3-8332-40ad6b7310f2",
                "UNBREAK_SPIRIT": "d5a857c6-ac57-4c82-b898-c998614e61bd",
                "UNWAVERING_SPIRIT": "e5ef6ddf-9621-484c-86ab-e02943b2145e"
            },
            "PROT": {
                "BLESS_SAC": "d740f1d1-23b0-4047-8ba1-d81aad23336b",
                "BOP": "3238af4a-e6bf-44a7-befe-0b3bb7a3d95d",
                "COUNSEL_1_2": "acd54740-8f4f-4ef4-bf1a-7fc26d12b74b",
                "COUNSEL_2_2": "e6d6e422-df70-4eca-a4f7-be3c357887a2",
                "FREEDOM": "1576891d-9e1e-40ff-9df1-a49e099472a2",
                "IMP_BLESSING": "c3e6af3d-81c1-440e-8f07-5c058b6500e9",
                "SAC_JUST": "0de55575-ade5-426f-b47c-584e507ac416",
                "UNBREAK_SPIRIT": "39bd329d-50e1-4e76-976c-360dedc08150"
            },
            "RET": {
                "BLESS_SAC": "534403c0-3c0d-45b3-9ef1-e3783fa41c08",
                "BOP": "785ffa5a-ad28-4cdc-8d55-d1035e67b2fc",
                "IMP_BLESSING": "bb6eed55-913d-4289-b32a-6affe9882b83",
                "SAC_JUST": "f9902ec9-b2b7-4b8a-95d7-f9a11d14eb73",
                "UNBREAK_SPIRIT": "fa1c4c3c-2365-4bc9-9b94-80f64b91ff0c"
            }
        },
        "PRIEST": {
            "DISC": {
                "BENDER": "c2b8f54e-bc64-4f3f-bc20-342458ce8b34",
                "LEAP_OF_FAITH": "10f830ed-9048-4865-97fb-ffc816f65f66",
                "MASS_DISPEL": "59502386-a715-4059-9eba-bf5539df99ac",
                "MOVE_WITH_GRACE": "c32b2053-7d2d-4c02-a7cc-6325e09b4b68",
                "POWER_INFUSION": "26fec4ad-7893-4450-a0d4-c0a2352b1f4d",
                "ULTI_PEN": "6e25b87c-bc9a-446a-97f3-26c82d84bb2c"
            },
            "HOLY": {
                "APO": "145705e0-34fa-408a-9c4c-0eb095164bd8",
                "GUARDIAN_ANGEL": "02d314aa-f05d-414b-8f82-15893e8b198f",
                "GUARDIAN_SPIRIT": "128f953d-cfef-4cdf-9a9d-72da96c01bde",
                "LEAP_OF_FAITH": "270c2610-9e02-4240-8eb2-4cb9c551fbe3",
                "MASS_DISPEL": "8a23386b-bec3-4c9c-8b91-6f0978cbd9e8",
                "MOVE_WITH_GRACE": "06ef5380-b89d-40ca-b37b-2b32edc3bf29",
                "POWER_INFUSION": "ec19073f-a8e0-4d9f-b011-66a417942590",
                "SALV": "dcc4d8cc-cd6e-4b5d-8ce1-d22b0695212a"
            },
            "SHADOW": {
                "LEAP_OF_FAITH": "e85a95e3-89cf-4a0a-8ecd-498d67ce906d",
                "MASS_DISPEL": "a9b0335f-6b6c-4acd-8ebb-e00ff27061f3",
                "MOVE_WITH_GRACE": "6135360a-e47e-4124-bbda-82ca19adf51e",
                "SANLAYN": "5d8b76f1-d88a-4f9c-a3b5-27aae8a8077f",
                "VAMP_EMBRACE": "ca124356-8a91-4702-8f65-d5f36efb7f74"
            }
        },
        "ROGUE": {
            "ASS": {},
            "OUT": {},
            "SUB": {}
        },
        "SHAMAN": {
            "ELE": {
                "ANCE_GUIDE": "88aed695-3e44-4edc-9399-a9f0017c4acc",
                "ASC_AIR": "adb2c731-a09c-4c5a-a5cb-787fe6c5d768",
                "CALL_OF_THE_ELEMENTS": "8e1ffa2c-8997-4646-b1d1-b2f6483955c7",
                "RECALL": "37b9b1a4-c4e5-4290-be71-3eeab3bcf617",
                "TOTEMIC_SURGE": "e49ee804-2e24-47ea-9004-5af8b327b73f",
                "WRT": "6414c5fb-36ad-430f-ae2b-edaa0a58bf31"
            },
            "ENH": {
                "ANCE_GUIDE": "b2448fed-b273-4d91-897b-749bd8c26c12",
                "ASC_AIR": "8a529137-da4a-4974-96e5-7beb6bb028d6",
                "CALL_OF_THE_ELEMENTS": "20670122-e9f4-464e-ab04-5c758107c629",
                "RECALL": "758b104b-e4db-4437-a728-06c0791981d6",
                "TOTEMIC_SURGE": "dfd7b903-eab9-4010-ab5d-2e09abd07fd6",
                "WRT": "176aea1a-5c86-40b5-bf15-f978497cdc97"
            },
            "RESTO": {
                "ANCE_GUIDE": "08b1232f-f4ea-4669-b3e1-62e89668784e",
                "APT": "7b46fd01-71ff-4529-b389-36572f789c27",
                "ASC": "c473579c-60b9-4a98-bd6e-75073994f1f3",
                "ASC_AIR": "5593c3e0-7e79-4351-9453-9b56a6a39293",
                "CALL_OF_THE_ELEMENTS": "0fc53a13-f373-47e8-bd6e-55f9a5e6bb09",
                "CURRENT_CONTROL": "ae467e33-fb17-47ab-8fc2-d548b0f3f715",
                "FIRST_ASCENDANT": "d8d6839a-17e6-4932-b0f1-0219b61a03f9",
                "MTT": "c895b503-d882-4b28-857e-82dd60f2767d",
                "RECALL": "246b8dc0-68dc-447e-bed9-27137dbcf377",
                "TOTEMIC_SURGE": "d1218a0b-f1c3-4c76-a222-b93cb9a5fd04",
                "WRT": "446f9fbe-49ec-44ae-b856-c8631d8ef5b8"
            }
        },
        "WARLOCK": {
            "AFFLI": {},
            "DEMO": {},
            "DEST": {}
        },
        "WARRIOR": {
            "ARMS": {},
            "FURY": {},
            "PROT": {}
        }
    }
}
